"use client";

import AppLogo from "@/components/ui/AppLogo";

export default function NautilusHeader() {
  return (
    <header className="w-full border-b border-gold-muted bg-deep-900/80 backdrop-blur-xl sticky top-0 z-50 no-print" style={{ backgroundColor: 'rgba(74,4,78,0.502)' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 xl:px-16 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AppLogo size={36} />
          <div className="flex flex-col">
            <span
              className="font-abril text-lg leading-tight gold-gradient-text"
              style={{ fontWeight: 400 }}>

              QuantuMe Nautilus
            </span>
            <span className="text-xs font-medium tracking-widest uppercase text-white/40 leading-tight">
              Avatar Life Blueprint
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-gold-DEFAULT animate-pulse" />
          <span className="text-xs font-medium text-white/50 tracking-wide hidden sm:block">
            AI Cosmically-Powered Avatar Mapping
          </span>
        </div>
      </div>
    </header>);

}